import React from "react"
import Img from "gatsby-image"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Container from "../components/container"
import styled from "@emotion/styled"

const Styles = styled.div`
    padding: 84px 0px;
   min-height: 100vh;


   iframe {
     max-width: 640px;
     width: 100%;
     height: auto;
     min-height: 340px;
   }
`

export default class Page extends React.Component {
  render() {
    const image = this.props.data.myImage.childImageSharp.fluid

    return (
      <Layout path="about">
        <SEO title="About" />
        <Styles>
        <Container>
          <div className="title">
            About
          </div>

          <iframe src="https://www.youtube.com/embed/uWTMEDEPw8c" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </Container>
        </Styles>
      </Layout>
    )
  }
}

export const query = graphql`
  {
    myImage: file(relativePath: { eq: "gatsby-astronaut.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
